import { useSelector } from "react-redux";
import { Roles } from "./roles";
export const useIsManager = () => {
  const roles = useSelector((state) => state.user?.info?.roles);

  if (!roles) return false;

  return roles
    .split(",")
    .map((r) => r.trim())
    .includes(Roles.MANAGER);
};
